import { FC } from 'react';
import React from 'react';

import { AccountLaborSummary } from './labor_summary';
import { AccountPerItemCreditsSummary } from './per_item_credits_summary';

export const AccountSummary: FC<{
  accountID: number;
}> = ({ accountID }) => (
  <>
    <AccountLaborSummary accountID={accountID} />
    <AccountPerItemCreditsSummary accountID={accountID} />
  </>
);
